{
  "title": "Welcome to bPanel",
  "description": "Add your first server and install bPanel in minutes."
}
